import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PageHeaderComponent } from '../../../../components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { DynamicForm, SelectOption } from '../../../../components/form-builder/form-builder.types';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { CompanyService } from '../company.service';
import { RefParamsService } from '../../ref-params/ref-params.service';
import { getCompanyFormObject } from '../utils/company-form-object';
import { CompanyRepository } from '../../../../store/company-state/company-state.repository';
import { MessageService } from 'primeng/api';
import { getFormBuilderObjectFactory } from '../../../../components/form-builder/utils/form-builder-factory';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SpinnerComponent } from '../../../../components/shared/spinner/spinner.component';
import { RefTypeEnum } from '@/types';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sm-add-company',
  imports: [
    PageHeaderComponent,
    FormBuilderComponent,
    ButtonModule,
    TabsModule,
    PageHeaderComponent,
    CommonModule,
    ButtonModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    MenuModule,
    DialogModule,
    InputTextModule,
    FormsModule,
    SelectModule,
    DrawerModule,
    TabsModule,
    SpinnerComponent,
    TranslateModule,
  ],
  templateUrl: './add-company.component.html',
  styleUrl: './add-company.component.scss',
})
export class AddCompanyComponent implements OnInit {
  //services
  companyService = inject(CompanyService);
  companyRepository = inject(CompanyRepository);
  refParamsService = inject(RefParamsService);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  router = inject(Router);

  @ViewChild(FormBuilderComponent) formBuilderComponent!: FormBuilderComponent;

  displaySubMenu = false;

  breadcrumb = [
    {
      label: 'settings.companyInfo.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.companyInfo',
      routerLink: ['/settings', 'company'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.new',
      routerLink: ['/settings', 'company', 'add'],
    },
  ];

  formObject: DynamicForm = getFormBuilderObjectFactory();
  formDateLoading = false;
  loading = false;

  companiesTypesOptions: SelectOption[] = [];
  companyCountriesOptions: SelectOption[] = [];
  companyCategoriesOptions: SelectOption[] = [];

  ngOnInit(): void {
    this.formDateLoading = true;
    this.companyRepository.reset();
    forkJoin({
      types: this.refParamsService.getSpecializedRefParams(RefTypeEnum.COMPANY_TYPE),
      categories: this.refParamsService.getSpecializedRefParams(RefTypeEnum.ACTIVITY_TYPE),
    }).subscribe(({ types, categories }) => {
      this.companiesTypesOptions = types.map(type => ({ name: type.code, code: type.id }));
      this.companyCategoriesOptions = categories.map(cat => ({ name: cat.code, code: cat.id }));

      this.formObject = getCompanyFormObject({
        store: this.companyRepository,
        companiesTypesOptions: this.companiesTypesOptions,
        companyCategoriesOptions: this.companyCategoriesOptions,
      });
      this.formDateLoading = false;
    });
  }

  addCompany() {
    this.loading = true;
    this.companyService.addCompany(this.companyRepository.get('dto')).subscribe({
      next: response => {
        this.loading = false;
        this.companyRepository.reset();
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: this.translate.instant('settings.company.message.success.added'),
        });
        this.router.navigate(['/settings', 'company', 'update', response.id]);
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.company.message.error.added'),
        });
      },
    });
  }
}
